/* eslint-disable @typescript-eslint/no-explicit-any */
// Usage: Factory.create(constructable, params)
// This code is derived from: https://stackoverflow.com/a/71214315
// This code is used to create an instance of a class from a constructor

export type Constructable<T = any, Params extends readonly any[] = any[]> = new (...params: Params) => T
export type ConstructorParameters<T extends abstract new (args: object) => any> = T extends abstract new (
	args: infer P
) => any
	? P
	: never
export class Factory {
	static create<T extends Constructable>(constructable: T, params?: ConstructorParameters<T>): InstanceType<T> {
		return new constructable(params)
	}
}
